import { createContext } from 'react';

import { BaseFilterChipProps } from '../BaseFilterChip/BaseFilterChip';

export const FilterChipContext = createContext<Pick<BaseFilterChipProps, 'size' | 'color' | 'role' | 'width'>>({
    size: 'm',
    color: 'contrast',
    role: 'value',
});
